import React from "react";
import {
  Address,
  FooterLink,
  InfoColumn,
  InfoContainer,
  InfoDescription,
  InfoRow,
  InfoTitle,
  InstitutionalBadges,
} from "./footer.styles";
import PhoneIcon from "assets/icons/phone.svg";
import EmailIcon from "assets/icons/email.svg";
import ArrowRight from "assets/icons/arrow-right.svg";
import RadarTransparenciaLogo from "assets/images/radar-transparencia-logo.webp";
import TcmBaLogo from "assets/images/tcm-ba-logo.png";
import { useAppState } from "main/context/app-context";

export function Footer() {
  const { applicationData } = useAppState();

  return (
    <footer id="footer">
      <InfoContainer background="blue">

        {/* LOGO CENTRAL */}
        <div className="footer-logo">
          <img
            src={`data:image/png;base64,${applicationData?.entity?.brandLogo}`}
            alt={applicationData?.entity?.name}
            height={120}
          />

          <InfoTitle>
            {applicationData?.entity?.name}
          </InfoTitle>
        </div>

        {/* COLUNAS */}
        <div className="footer-grid">

          {/* COLUNA 1: Endereço + Horário de atendimento */}
          <InfoColumn>
            <InfoTitle>Endereço</InfoTitle>

            <InfoDescription>
              {applicationData?.entity?.address?.formattedAddress}
            </InfoDescription>

            <InfoTitle>Horário de atendimento</InfoTitle>

            <InfoDescription>
              O funcionamento da {applicationData?.entity?.name}
                é de segunda à sexta-feira das 8h às 14h.
            </InfoDescription>
          </InfoColumn>

          {/* COLUNA 2: Fale conosco, centralizado */}
          <InfoColumn>
            <InfoTitle>Fale conosco</InfoTitle>

            <InfoRow>
              <img src={PhoneIcon} alt="Telefone" />

              <InfoDescription>
                {applicationData?.entity?.contact?.formattedBusinessPhone}
              </InfoDescription>
            </InfoRow>

            <InfoRow>
              <img src={EmailIcon} alt="Email" />

              <InfoDescription>
                {applicationData?.entity?.contact?.email}
              </InfoDescription>
            </InfoRow>
          </InfoColumn>

          {/* COLUNA 3: LGPD, Acessibilidade, Mapa do Site, centralizado */}
          <InfoColumn>
            <InfoRow>
              <FooterLink href="/pagina/lgpd">
                Política de Privacidade (LGPD)
              </FooterLink>

              <img
                src={ArrowRight}
                alt="LGPD"
              />
            </InfoRow>

            <InfoRow>
              <FooterLink href="/acessibilidade">
                Declaração de Acessibilidade
              </FooterLink>

              <img
                src={ArrowRight}
                alt="Acessibilidade"
              />
            </InfoRow>

            <InfoRow>
              <FooterLink href="/mapa-do-site">
                Mapa do Site
              </FooterLink>

              <img
                src={ArrowRight}
                alt="Mapa do Site"
              />
            </InfoRow>
          </InfoColumn>

        </div>

        {/* RODAPÉ FINAL */}
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} {applicationData?.entity?.name}</span>

          <InstitutionalBadges>
            <a
              href="https://radardatransparencia.atricon.org.br/"
              target="_blank"
              rel="noopener noreferrer"
              title="Radar da Transparência Pública"
            >
              <img src={RadarTransparenciaLogo} alt="Radar da Transparência Pública" />
            </a>

            <a
              href="https://www.tcm.ba.gov.br/"
              target="_blank"
              rel="noopener noreferrer"
              title="Tribunal de Contas dos Municípios do Estado da Bahia"
            >
              <img src={TcmBaLogo} alt="Tribunal de Contas dos Municípios do Estado da Bahia" />
            </a>
          </InstitutionalBadges>
        </div>

      </InfoContainer>
    </footer>
  );
}


//            </InfoContainer>
//         <img src={"data:image/png;base64, " + applicationData?.entity?.brandLogo} alt={applicationData?.entity?.name} height={100} />
//         <InfoContainer background="white" alignCenter>
//           <Address>
//             <strong>{applicationData?.entity?.name}</strong> <br />
//             {applicationData?.entity?.address?.formattedAddress}
//           </Address> 
//         </InfoContainer>
//       </>
//     </footer>
//   );
// }
